import LabelSection from 'components/sections/LabelSection'
import ActionBarDetailWrapper from 'components/wrappers/pages/ActionBarDetailWrapper'
import {reduxForm, formValueSelector, Field} from 'redux-form'
import {connect} from 'react-redux'
import styles from './CategoryForm.css'
import SettingField from 'components/Fields/ReduxForm/SettingField'
import {onClickCancel, showDeleteModal} from 'actions/ingredients/category'

const validate = (values) => {
  const errors = {}
  if (!values.name) {
    errors.name = 'Please enter a value'
  }
  return errors
}

class CategoryForm extends React.Component {
  render () {
    const {ingCategory, handleSubmit, outlets, isSubmitting} = this.props
    return (<form className={styles.wrapper} onSubmit={(e) => { e.preventDefault() }}>
      <div className={`${styles['content-wrapper']} ingredient-categories-content-wrapper`}>
        <LabelSection title='ingredient category' />
        <div className='row'>
          <div className='col-sm-12'>
            <div className='form-group'>
              <Field
                component={SettingField}
                name='name'
                type='text'
                placeholder='Ingredient Category Name'
              />
            </div>
          </div>
        </div>
      </div>
      <ActionBarDetailWrapper>
        <span className='pull-left'>
          {ingCategory.id && <button className='btn btn-danger' onClick={this._onClickDelete} type='button' disabled={isSubmitting}><i className='fa fa-trash' /></button>}
        </span>
        <span className='pull-right'>
          <button className='btn btn-default mr-10px' onClick={this._onCancel} type='button' disabled={isSubmitting}>Cancel</button>
          {outlets.length > 1 && !ingCategory.id && <button
            type='button'
            className='btn btn-primary mr-10px'
            onClick={handleSubmit(this._onSubmitCreateAllOutlet)}
            disabled={isSubmitting}>
            Save to All Outlet
          </button>}
          <button
            type='button'
            className='btn btn-primary'
            disabled={isSubmitting}
            onClick={handleSubmit(this._onSubmitSave)}>
            Save
          </button>
        </span>
      </ActionBarDetailWrapper>
    </form>)
  }

  _onCancel = () => {
    const {dispatch} = this.props
    dispatch(onClickCancel())
  }

  _onSubmitCreateAllOutlet = (values) => {
    this.props.onSubmit({...values, action: 'save_to_all_outlet', name: values.name.trim()})
  }

  _onSubmitSave = (values) => {
    this.props.onSubmit({...values, action: 'save', name: values.name.trim()})
  }

  _onClickDelete = () => {
    this.props.dispatch(showDeleteModal())
  }
}

const selector = formValueSelector('ingCategory')

function mapStateToProps (state) {
  const {outlets, isSubmitting} = state.ingredients.category
  return {
    outlets,
    isSubmitting,
    ingCategory: {
      id: selector(state, 'id')
    }
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

const mapForm = {
  form: 'ingCategory',
  validate,
  touchOnBlur: false,
  touchOnChange: false
}

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(mapForm)(CategoryForm))



// WEBPACK FOOTER //
// ./app/pages/Ingredient/Category/CategoryDetail/CategoryForm/CategoryForm.js